import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardOptionsComponent } from '../../core/visual/card/options-card.component';

export interface MatPbxAccountsSelectDialogData {
  accounts: any[];
  selectedAccounts: string[];
  title: string;
  cardTitle: string;
  excludeValues: string[];
}

@Component({
    selector: 'app-mat-pbx-accounts-select-dialog',
    template: `
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
      <div fxFlex>{{title}}</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
    <mat-dialog-content class="mat-typography">
      <form>
        <app-options-card [title]="cardTitle" [options]="allAccounts" [collapsed]="false"
                          [(checkedOptions)]="checkedAccountsOptions" [showSearchInput]="true"></app-options-card>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button color="primary" (click)="onProcessConfirm()" cdkFocusInitial>Confirm</button>
    </mat-dialog-actions>
  `,
    standalone: true,
    imports: [
        MatDialogTitle,
        FlexModule,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardOptionsComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class MatPbxAccountsSelectDialogComponent implements OnInit, OnDestroy {

  title = '';
  cardTitle = '';
  checkedAccountsOptions = [];
  allAccounts = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: MatPbxAccountsSelectDialogData,
              public dialogRef: MatDialogRef<MatPbxAccountsSelectDialogComponent>) {
  }

  ngOnInit() {
    console.log('ngOnInit');
    this.checkedAccountsOptions = [...this.data.selectedAccounts];
    this.allAccounts = [...this.data.accounts.filter(x => (this.data.excludeValues || []).indexOf(x.value) === -1)];
    this.title = this.data.title;
    this.cardTitle = this.data.cardTitle;
  }

  ngOnDestroy() {
  }

  async onProcessConfirm() {
    this.dialogRef.close(this.checkedAccountsOptions);
  }
}
